import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { styled } from '../components/styled';
import SpButton from '../components/atoms/SpButton';
import SpTextInput from '../components/atoms/SpTextInput';
import SpText from '../components/atoms/SpText';
import SpDialog from '../components/atoms/SpDialog';
import { theme } from '../components/theme';
import { changePassword, logoutUser, loginUser, registerUser, loginUserSocial } from '../models/actions/Auth';
import { labels } from './shared/translations';
import { Grid, Typography } from '@material-ui/core';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import SpLoadingButton from '../components/atoms/SpLoadingButton';
import { logo_url_dev } from '../config';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import SpIconAndTextButton from '../components/atoms/SpIconAndTextButton';
import { Google } from '@mui/icons-material';
import { UserSessionContext } from '../App';

const StyledRowDialog = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '4%'
});

const StyledColumnLogin = styled(Grid)({
  alignSelf: 'center',
  padding: '2%',
  marginTop: 50,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '40%',
  border: '1px solid #4DAC27',
  borderRadius: 20,
  color: '#4DAC27',
  borderColor: '#4DAC27',
  backgroundColor: '#FFF',
  boxShadow: ` 5px 5px 10px ${theme.colors.mainGreen.secondary} `
});

const StyledColumn = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2%',
  pX: '20%'
});

const LoginUserDelete = (props) => {
  const [open, setOpen] = useState(false);
  const [emailForgotPassword, setEmailForgot] = useState(null);
  const [inputError, setInputError] = useState('');
  const [profile, setProfile] = useState([]);
  const [googleUser, setGoogleUser] = useState(null);
  const { authData, setAuthData } = useContext(UserSessionContext);

  const history = useHistory();

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => setGoogleUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });

  useEffect(() => {
    if (googleUser) {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${googleUser.access_token}`, {
          headers: {
            Authorization: `Bearer ${googleUser.access_token}`,
            Accept: 'application/json'
          }
        })
        .then(async (res) => {
          const response = await loginUserSocial({ email: res.data?.email });
          setAuthData({ accessToken: response.data.token, userId: response.data.id });
          setProfile(res.data);
          response &&
            history.push({
              // no need
              pathname: '/users-delete/complete-request',
              state: { from: 'fromUserDelete', data: res.data }
            });
        })
        .catch((err) => {
          props.snackbarShowErrorMessage("C'é stato un errore nella fase di accesso alla piattaforma");
          console.log(err);
        });
    }
  }, [googleUser]);

  const sendForgotPassEmail = async () => {
    const response = await changePassword(emailForgotPassword);
    if (response.status !== 200) {
      setInputError(response.data.message);
    } else {
      return setOpen(false);
    }
  };

  const responseFacebook = (response) => {
    if (response?.accessToken) {
      history.push('/users-delete/complete-request');
    } else {
      props.snackbarShowErrorMessage("C'é stato un errore nella fase di accesso alla piattaforma");
    }
  };

  return (
    <>
      <StyledColumnLogin
        container
        spacing={2}
        direction="column"
        alignItems="center"
      >
        <Grid
          item
          xs={10}
          style={{ width: '100%' }}
        >
          <img
            style={{ width: '100%' }}
            src={logo_url_dev}
          />
        </Grid>
        <Grid
          item
          xs={8}
        >
          <SpText>Effettua l'accesso con il tuo account per richiedere l'eliminazione</SpText>
        </Grid>
        <Grid
          item
          xs={8}
          style={{ maxHeight: '30px !important' }}
        >
          <FacebookLogin
            containerStyle={{
              maxHeight: '30px !important',
              height: '30px !important',
              width: '100%'
            }}
            buttonStyle={{
              padding: '5px 12px',
              maxHeight: '30px !important',
              height: '30px !important',
              border: '2px solid ' + theme.colors.mainGreen.main,
              borderRadius: '20px',
              color: 'white',
              fontSize: '1.2rem',
              '&:hover': {
                background: 'transparent !important'
              },
              '&:disabled': {
                color: theme.colors.mainGreen.secondary,
                background: 'transparent !important',
                opacity: 0.23
              },
              width: '100%'
            }}
            appId={process.env.FACEBOOK_AUTH_ID}
            autoLoad={false}
            fields="name,email,picture"
            scope="public_profile,user_friends"
            callback={() => responseFacebook()}
            icon="fa-facebook"
          />
        </Grid>
        <Grid
          item
          xs={8}
        >
          <SpIconAndTextButton
            isIconLeft={true}
            textVariant="tableText"
            variant="actionButton"
            text={'Accedi con Google'}
            onClick={() => login()}
          >
            <Google style={{ width: 20, color: theme.colors.mainGreen.main, height: 30, marginRight: 8, cursor: 'pointer', paddingTop: '5px', paddingBottom: '5px' }} />
          </SpIconAndTextButton>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <SpText textAlign={'center'}>
            Effettuando l'accesso accetti <a href="https://www.iubenda.com/termini-e-condizioni/67439261">Termini e Condizioni</a> e <a href="https://www.iubenda.com/privacy-policy/67439261">Privacy Policy</a>
          </SpText>
        </Grid>
      </StyledColumnLogin>
      <SpDialog
        open={open}
        setOpen={setOpen}
        title={labels.login.passwordLostDialog.title}
      >
        <StyledColumn>
          <SpText>{labels.login.passwordLostDialog.subtitle}</SpText>
          <StyledRowDialog>
            <SpTextInput
              name="emailForgotPass"
              value={emailForgotPassword}
              onChange={(e) => setEmailForgot(e.currenTarget.value)}
              label={labels.login.passwordLostDialog.label}
            />
          </StyledRowDialog>
          <StyledRowDialog>
            <SpButton
              onClick={() => sendForgotPassEmail()}
              buttonType="accept"
              text={labels.login.passwordLostDialog.send}
            />
          </StyledRowDialog>
        </StyledColumn>
      </SpDialog>
    </>
  );
};

export default withSnackbar(LoginUserDelete);
